const validate = values => {
  const errors = {};
  if (!values.description) {
    errors.description = 'Favor informar a descrição do tipo de despesa! ';
  }
  return errors;
};

export default validate;
